























































import Vue from 'vue'
import { NavigationPill } from '@/components/partials/'
import { ValuationRecords, ValuationConcepts } from '@/components/history'
import { SearchValuations } from '@/components/valuation/'
import RouteLink from '@/interfaces/app/RouteLink'
import { menuLinks } from '@/router/'

export default Vue.extend({
  name: 'history',
  components: {
    NavigationPill,
    ValuationRecords,
    ValuationConcepts,
    SearchValuations,
  },
  computed: {
    currentTabUrl(): string {
      return this.$route.params.type || ''
    },
    links(): RouteLink[] {
      const historyLinks = menuLinks.find(l => l.name === this.$options.name)
      return historyLinks!.childRoutes || []
    },
  },
  methods: {
    isLinkActive(link: RouteLink): boolean {
      return this.$route.params.type === link.params!.type
    },
  },
})
